// PRODUCTION — add-step modal wired to flow editor context
import React from 'react'
import { AddStepModal } from 'src/components/flow-editor/FlowModals'
import { useFlowEditorContext } from 'src/pages/admin/flow-editor/context/useFlowEditorContext'

export function FlowEditorAddStepModal() {
  const { addStepsToGroup, closeAddStepModal, showAddModal, steps } = useFlowEditorContext()

  return (
    <AddStepModal
      open={showAddModal}
      currentStepTypes={steps.map((s) => s.type)}
      onClose={closeAddStepModal}
      onAdd={addStepsToGroup}
    />
  )
}
